export class Story {
  id: string = '';
  title: string = '';

  constructor() {
  }
}
